import { inject, Injectable } from '@angular/core';

import { AppSettings } from '../../models';
import { APP_ENVIRONMENT, Environment, OAuthGrants } from '../../types';
import { ConfigProvider } from './config-provider';

@Injectable()
export class ConfigEnvironmentProvider implements ConfigProvider {
  private readonly environment: Environment = inject(APP_ENVIRONMENT);
  public readonly loadOrder = 1;

  public async getAppSettings(appSettings: AppSettings): Promise<AppSettings> {
    appSettings.onlyWeb = this.environment.onlyWeb;

    if (this.environment.pinConfiguration) {
      appSettings.pinConfiguration = this.environment.pinConfiguration;
    }

    const grants = this.environment.authentication?.grants;
    if (grants && grants.length > 0) {
      const grantSet = new Set<OAuthGrants>(grants);
      appSettings.supportedOAuthGrants = grantSet;
      appSettings.isOAuthCodeGrantSupported = grantSet.has('code');
    }

    const envSentry = this.environment.sentry;
    if (envSentry?.dsn) {
      appSettings.sentry = {
        dsn: envSentry.dsn,
        tracesSampleRate: envSentry.tracesSampleRate ?? 0.1,
        replaysSessionSampleRate: envSentry.replaysSessionSampleRate ?? 0.1,
        replaysOnErrorSampleRate: envSentry.replaysOnErrorSampleRate ?? 0.3,
      };
    }

    return Promise.resolve(appSettings);
  }
}
